export const t = (key, env, text) => {
	if (key == null || typeof key !== "object") {
		key == null && console.error("translation not found", text);
		return text || "--";
	}
	return key[env];
};

// Log Status Handler
export const TOAST_SESSION_EXPIRED = {
	eng: "Session Expired",
	bhs: "Sesi berakhir",
};
export const TOAST_USER_NOT_VALID = {
	eng: "User Not Valid",
	bhs: "Pengguna Tidak Valid",
};

// Loading Component
export const LOADING_LABEL = { eng: "Loading...", bhs: "Memuat..." };

// No content Component
export const NO_CONTENT_DEFAULT_LABEL = {
	eng: "No Content",
	bhs: "Tidak ada konten",
};
export const NO_CONTENT_DEFAULT_DESCRIPTION = {
	eng: "No Content Available",
	bhs: "Tidak ada konten tersedia",
};

// Header
export const HEADER_SRC_PLACEHOLDER = {
	eng: "Search for Major, College",
	bhs: "Cari Jurusan, Kampus",
};
export const ASK_MORE = {
	eng: "Ask more",
	bhs: "Tanya lebih lanjut",
};
export const REGISTER = {
	eng: "Sign up",
	bhs: "Daftar",
};
export const SIGN_IN = {
	eng: "Log in",
	bhs: "Masuk",
};
export const FAVORITE = {
	eng: "Favorite",
	bhs: "Favorit",
};
export const DASHBOARD = {
	eng: "Dashboard",
	bhs: "Dashboard",
};
export const LOGOUT = {
	eng: "Log out",
	bhs: "Keluar",
};
export const LOGGED_OUT = {
	eng: "Logged out",
	bhs: "Keluar Akun",
};

// Footer
export const CONTACT_US = {
	eng: "Contact Us",
	bhs: "Hubungi Kami",
};
export const SITE_LINKS = {
	eng: "Site Links",
	bhs: "Tautan Situs"
}
export const PRIVACY_POLICY = {
	eng: "Privacy Policy",
	bhs: "Kebijakan Privasi",
};
export const TNC = {
	eng: "Terms & Conditions",
	bhs: "Syarat dan Ketentuan",
};
export const MAIL_TO_SUBJECT = {
	eng: "Inquiry / Complaint",
	bhs: "Pertanyaan / Keluhan",
};

// Home Component
export const COLLEGE = {
	eng: "College",
	bhs: "Kampus",
};
export const MAJOR = {
	eng: "Major",
	bhs: "Jurusan",
};
export const CAREER = {
	eng: "Career",
	bhs: "Karier",
};
export const SCHOLARSHIP = {
	eng: "Scholarship",
	bhs: "Beasiswa",
};
export const SEARCH_COLLEGE_CITY = {
	eng: "Search colleges located in {0}",
	bhs: "Cari kampus yang terletak di {0}",
};
export const NO_ITEM_FOUND_QUERY = {
	eng: "No item found for {0}",
	bhs: "Tidak ada {0} ditemukan",
};
export const CITY = {
	eng: "City",
	bhs: "Kota",
};
export const RECENTLY_VIEW_COLLEGE = {
	eng: "Recently Viewed College",
	bhs: "Kampus yang Terakhir Dilihat",
};
export const RECENTLY_VIEW_MAJOR = {
	eng: "Recently Viewed Major",
	bhs: "Jurusan yang Terakhir Dilihat",
};
export const OUR_COLLEGE_RECOMMENDATION = {
	eng: "Our Recommended College",
	bhs: "Kampus Rekomendasi Kami",
};
export const OUR_MAJOR_RECOMMENDATION = {
	eng: "Our Recommended Major",
	bhs: "Jurusan Rekomendasi Kami",
};
export const VIEW_ALL = {
	eng: "View All",
	bhs: "Lihat Semua",
};
export const LOGOUT_SUCCEED = {
	eng: "User logged out",
	bhs: "Pengguna berhasil keluar",
};
export const ACCREDITATION = {
	eng: "Accreditation",
	bhs: "Akreditasi",
};
export const ASIAN_RANKING = {
	eng: "QS Asia Ranking",
	bhs: "QS Asia Ranking",
};
export const WORLD_RANKING = {
	eng: "QS World Ranking",
	bhs: "QS World Ranking",
};
export const START = {
	eng: "Start",
	bhs: "Mulai dari",
};
export const SMT = {
	eng: "smt",
	bhs: "smt",
};
export const COMING_SOON = {
	eng: "Coming Soon",
	bhs :"Segera hadir"
}
export const COMING_SOON_DESCRIPTION = {
	eng: "We're working hard to bring you something amazing. Stay tuned!",
	bhs: "Kami bekerja keras untuk membawakan Anda sesuatu yang luar biasa.Pantau terus!"
}

// PS Login Modal
export const EMAIL_USERNAME = {
	eng: "Email/Username",
	bhs: "Email/Username",
};
export const PASSWORD = {
	eng: "Password",
	bhs: "Password/Kata Sandi",
};
export const FORGOT_PASSWORD = {
	eng: "Forgot Password",
	bhs: "Lupa Kata Sandi",
};
export const FILL_CORRECT_PASSWORD = {
	eng: "Password Empty",
	bhs: "Kata Sandi kosong",
};
export const FILL_CORRECT_USER_ID = {
	eng: "Email/Username Empty",
	bhs: "Email/Nama Pengguna kosong",
};
export const FILL_CORRECT_USER_ID_PASSWORD = {
	eng: "User Name & Password Empty",
	bhs: "Nama Pengguna & Kata Sandi kosong",
};

// Login Modal
export const LOGIN = {
	eng: "Login",
	bhs: "Masuk",
};
export const OR_FILL_FORM_BELOW = {
	eng: "Or fill the form below",
	bhs: "Atau isi form di bawah",
};
export const NEW_USER = {
	eng: "New User",
	bhs: "Pengguna Baru",
};
export const CLICK_HERE_CREATE_ACCOUNT = {
	eng: "Click here to create an account!",
	bhs: "Klik di sini untuk buat akun!",
};
export const LOGIN_SUCCESS = {
	eng: "Login success!",
	bhs: "Berhasil masuk!",
};
export const ERROR_INVALID_LOGIN = {
	eng: "Login failed, please check your username and/or password!",
	bhs: "Gagal untuk masuk, silakan periksa username dan/atau password kamu!",
};

// Create Account
export const LETS_CREATE_ACCOUNT = {
	eng: "Let's create a Direktori Kampus account",
	bhs: "Ayo buat akun Direktori Kampus",
};
export const SIGNUP_WITH_GOOGLE = {
	eng: "Sign up with Google",
	bhs: "Daftar dengan Google",
};
export const ENTER = {
	eng: "Enter",
	bhs: "Masukkan",
};
export const FIRST_NAME = {
	eng: "First Name",
	bhs: "Nama Depan",
};
export const LAST_NAME = {
	eng: "Last Name",
	bhs: "Nama Belakang",
};
export const EMAIL = {
	eng: "Email",
	bhs: "Email",
};
export const USERNAME = {
	eng: "Username",
	bhs: "Username/Nama Pengguna",
};
export const ALREADY_HAVE_ACCOUNT = {
	eng: "Already have an account?",
	bhs: "Sudah punya akun?",
};
export const CLICK_HERE_LOGIN = {
	eng: "Click here to log in",
	bhs: "Klik di sini untuk masuk",
};
export const CONFIRM_PASSWORD = {
	eng: "Confirm Password",
	bhs: "Konfirmasi Password/Kata Sandi",
};
export const PASSWORD_NOT_MATCHED = {
	eng: "Password and Confirm Password does not match",
	bhs: "Kata Sandi dan Konfirmasi Kata Sandi tidak sama",
};
export const ACCEPT_PRIVACY_POLICY = {
	eng: "I accept with the privacy policy of",
	bhs: "Saya setuju dengan kebijakan privasi",
};
export const PARENT_UNDERAGE_CONSENT = {
	eng: "This agreement needs to be given to your parent if you're still under legal age.",
	bhs: "Persetujuan ini harus diberikan oleh orang tua Anda jika Anda masih di bawah umur.",
};
export const REGISTER_SUCCESS = {
	eng: "Successfully creating a new account",
	bhs: "Berhasil membuat akun baru",
};
export const USERNAME_ACCEPT = {
	eng: "Username can only accept letters, digits, @, ., +, -, and _",
	bhs: "Username/Nama Pengguna hanya menerima huruf, angka, @, ., +, -, dan _",
};

// Forgot Password
export const FORGOT_PASSWORD_MESSAGE = {
	eng: "Please enter your username",
	bhs: "Silakan masukkan nama pengguna anda",
};
export const FORGOT_PASSWORD_MAIL_SENT = {
	eng: "We have sent a confirmation email. please check your email to reset your password",
	bhs: "Kami telah mengirimkan email konfirmasi. silakan cek email Anda untuk mengatur ulang kata sandi Anda",
};
export const FORGOT_PASSWORD_MAIL_SENT_SHORT = {
	eng: "Confirmation Email Sent!",
	bhs: "Email konfirmasi terkirim!",
};
export const SEND = {
	eng: "Send",
	bhs: "Kirim",
};
export const RESEND = {
	eng: "Resend",
	bhs: "Kirim Ulang",
};
export const BACK_TO_HOME = {
	eng: "Back to the Homepage",
	bhs: "Kembali ke Halaman Utama",
};
export const HAVENT_GOT_EMAIL = {
	eng: "Haven't got e-mail?",
	bhs: "Belum mendapatkan e-mail?",
};

// Profile Detail
export const EDIT_PROFILE = {
	eng: "Edit Profile",
	bhs: "Ubah Profil",
};
export const CHANGE_PASSWORD = {
	eng: "Change Password",
	bhs: "Ganti Password/Kata Sandi",
};
export const CURRENT_PASSWORD = {
	eng: "Current Password",
	bhs: "Password/Kata Sandi saat ini",
};
export const NEW_PASSWORD = {
	eng: "New Password",
	bhs: "Password/Kata Sandi baru",
};
export const SAVE_PROFILE = {
	eng: "Save Profile",
	bhs: "Simpan Profil",
};
export const PLEASE_FILL_NECESSARY_FORM = {
	eng: "Please fill all necessary form",
	bhs: "Mohon mengisi bagian yang wajib diisi",
};
export const PROFILE_DETAIL_CHANGED = {
	eng: "Profile detail changed!",
	bhs: "Detil profil diubah!",
};
export const PASSWORD_CHANGED = {
	eng: "Password changed!",
	bhs: "Kata Sandi/Password diubah!",
};
export const PROFILE = {
	eng: "Profile",
	bhs: "Profil",
};

// Listing
export const SHOWING = {
	eng: "Showing",
	bhs: "Menampilkan",
};
export const COLLEGES = {
	eng: "College(s)",
	bhs: "Kampus",
};
export const MAJORS = {
	eng: "Major(s)",
	bhs: "Jurusan",
};
export const CAREERS = {
	eng: "Careers(s)",
	bhs: "Karier",
};
export const SCHOLARSHIPS = {
	eng: "Scholarships(s)",
	bhs: "Beasiswa",
};
export const VIEW_MORE = {
	eng: "View More",
	bhs: "Tampilkan Lebih Banyak",
};
export const VIEW_MORE_CITY = {
	eng: "View More Cities",
	bhs: "Tampilkan Lebih Banyak Kota",
};
export const VIEW_MORE_COUNTRY = {
	eng: "View More Countries",
	bhs: "Tampilkan Lebih Banyak Negara",
};
export const FILTERS = {
	eng: "Filters",
	bhs: "Filter",
};
export const APPLIED = {
	eng: "applied",
	bhs: "diterapkan"
}
export const VIEW_MORE_DOMESTIC = {
	eng: "View More",
	bhs: "Lihat selengkapnya"
}

// Filter Box
export const SRC_PLACEHOLDER = {
	eng: "Search...",
	bhs: "Cari...",
};
export const SRC_BY_PLACEHOLDER = {
	eng: "Search {0} Name",
	bhs: "Cari Nama {0}",
};
export const RESET = {
	eng: "Reset",
	bhs: "Reset",
};
export const APPLY = {
	eng: "Apply",
	bhs: "Terapkan",
};
export const MIN = {
	eng: "Min",
	bhs: "Min"
}
export const MAX = {
	eng: "Max",
	bhs: "Maks"
}

// College Listing
export const LOCATION = {
	eng: "Location",
	bhs: "Lokasi",
};
export const SRC_LOCATION = {
	eng: "Search Location",
	bhs: "Cari Lokasi",
};
export const SRC_ACCREDITATION = {
	eng: "Search Accreditation",
	bhs: "Cari Akreditasi",
};
export const DEGREE = {
	eng: "Degree",
	bhs: "Level Studi",
};
export const SRC_MAJOR = {
	eng: "Search Major",
	bhs: "Cari Jurusan",
};
export const ALL_MAJORS = {
	eng: "All majors",
	bhs: "Semua jurusan",
};
export const DIPLOMA_1 = {
	eng: "Diploma 1",
	bhs: "Diploma 1",
};
export const DIPLOMA_2 = {
	eng: "Diploma 2",
	bhs: "Diploma 2",
};
export const DIPLOMA_3 = {
	eng: "Diploma 3",
	bhs: "Diploma 3",
};
export const DIPLOMA_4 = {
	eng: "Diploma 4",
	bhs: "Diploma 4",
};
export const UNDERGRAD = {
	eng: "Undergraduate",
	bhs: "Sarjana",
};
export const POSTGRAD = {
	eng: "Postgraduate",
	bhs: "Pascasarjana",
};
export const DOCTORAL = {
	eng: "Doctoral",
	bhs: "Doktoral",
};
export const PROFESSION = {
	eng: "Profession",
	bhs: "Profesi",
};
export const SPECIALIST_1 = {
	eng: "Specialist 1",
	bhs: "Spesialis 1",
};
export const SPECIALIST_2 = {
	eng: "Specialist 2",
	bhs: "Spesialis 2",
};
export const SOMETHING_WENT_WRONG_TRY_AGAIN = {
	eng: "Something went wrong please try again after some time!",
	bhs: "Ada yang tidak beres, coba lagi setelah beberapa saat!",
};
export const STATE_UNIVERSITY_ABBV = {
	eng: "State",
	bhs: "Negeri",
};
export const PRIVATE_UNIVERSITY_ABBV = {
	eng: "Private",
	bhs: "Swasta",
};
export const SHOW_ALL = {
	eng: "Show All",
	bhs: "Lihat Semua",
};
export const YES = {
	eng: "Yes",
	bhs: "Ya",
};
export const NO = {
	eng: "No",
	bhs: "Tidak",
};
export const NO_ACCREDITATION = {
	eng: "No Accreditation",
	bhs: "Tidak Terakreditasi",
};
export const OTHER_ACCREDITATION = {
	eng: "Other Accreditation",
	bhs: "Akreditasi Lainnya",
};
export const SELECTED = {
	eng: "{0} selected",
	bhs: "{0} terpilih",
};

// Major Listing
export const FACULTY_NAME = {
	eng: "Faculty Name",
	bhs: "Bidang Studi",
};
export const TUITION_FEE_SMT = {
	eng: "Tuition Fee per semester",
	bhs: "Biaya Per Semester",
};
export const ALL_FACULTY = {
	eng: "All Faculties",
	bhs: "Semua bidang studi",
};
export const ALL_TUITION = {
	eng: "All Tuition",
	bhs: "Semua biaya",
};
export const SRC_FACULTY = {
	eng: "Search Faculty",
	bhs: "Cari Fakultas",
};

// Career Listing
export const SECTOR = {
	eng: "Sector",
	bhs: "Karier",
};
export const ALL_SECTOR = {
	eng: "All Sectors",
	bhs: "Semua Karier",
};

// Scholarship Listing
export const SCHOLARSHIP_GIVER = {
	eng: "Scholarship giver",
	bhs: "Jenis",
};
export const ALL_SCHOLARSHIP_GIVER = {
	eng: "All Scholarship Giver",
	bhs: "Semua Jenis",
};
export const GOVERNMENT = {
	eng: "Government",
	bhs: "Pemerintah",
};
export const ORGANIZATION = {
	eng: "Organization",
	bhs: "Organisasi",
};
export const INTERNATIONAL = {
	eng: "International",
	bhs: "Internasional",
};
export const DESTINATION = {
	eng: "Destination",
	bhs: "Tujuan",
};
export const ALL_DESTINATION = {
	eng: "All Destinations",
	bhs: "Semua Tujuan",
};
export const DOMESTIC = {
	eng: "Domestic",
	bhs: "Dalam Negeri",
};
export const ABROAD = {
	eng: "Abroad",
	bhs: "Luar Negeri",
};
export const INTERNATIONAL_DESTINATION = {
	eng: "International",
	bhs: "Luar Negeri",
};
export const UNTIL = {
	eng: "Until",
	bhs: "Periode",
};

// College Details
export const GENERAL_INFORMATION = {
	eng: "General Information",
	bhs: "Informasi Umum",
};
export const COLLEGE_NOT_FOUND = {
	eng: "Selected college not found!",
	bhs: "Tidak dapat menemukan kampus terpilih",
};
export const RANKING = {
	eng: "Ranking",
	bhs: "Ranking",
};
export const BASED_ON_WEBOMETRIC_INDO = {
	eng: "Based on Webometrics Country Rank in Indonesia",
	bhs: "Berdasarkan Webometrics Country Rank di Indonesia",
};
export const BASED_ON_WEBOMETRIC_WORLD = {
	eng: "Based on Webometrics Country Rank",
	bhs: "Berdasarkan Webometrics Country Rank",
};
export const STATE_UNIVERSITY = {
	eng: "State University",
	bhs: "Universitas Negeri",
};
export const PRIVATE_UNIVERSITY = {
	eng: "Private University",
	bhs: "Universitas Swasta",
};
export const ADD_TO_FAVORITES = {
	eng: "Add to Favorites",
	bhs: "Tambahkan ke Favorit",
};
export const DOWNLOAD_BROCHURE = {
	eng: "Download Brochure",
	bhs: "Download Brosur",
};
export const REMOVE_FROM_FAVORITES = {
	eng: "Remove from Favorites",
	bhs: "Hapus dari Favorit",
};
export const STUDENT = {
	eng: "Student",
	bhs: "Mahasiswa",
};
export const LECTURER = {
	eng: "Lecturer",
	bhs: "Dosen",
};
export const WEBSITE = {
	eng: "Website",
	bhs: "Website",
};
export const PHONE = {
	eng: "Phone",
	bhs: "Nomor Telepon",
};
export const WHATSAPP = {
	eng: "WhatsApp",
	bhs: "WhatsApp",
};
export const DATA_NOT_AVAILABLE = {
	eng: "Data is not available",
	bhs: "Data tidak tersedia",
};
export const COLLEGE_DESCRIPTION = {
	eng: "College Description",
	bhs: "Deskripsi Kampus",
};
export const SRC_MAJOR_PLACEHOLDER = {
	eng: "Search Major",
	bhs: "Cari Jurusan",
};
export const FACILITIES = {
	eng: "Facilities",
	bhs: "Fasilitas",
};
export const FACULTIES_AND_MAJORS = {
	eng: "Faculties and Majors",
	bhs: "Fakultas dan Jurusan",
};
export const GENERAL_TUITION_FEES = {
	eng: "General Tuition Fees",
	bhs: "Biaya Kuliah",
};
export const SCHOLARSHIP_INFORMATION = {
	eng: "Scholarship Information",
	bhs: "Informasi Beasiswa",
};
export const MORE_INFO = {
	eng: "More Info",
	bhs: "Informasi Lebih Banyak",
};
export const TESTIMONY = {
	eng: "Testimony",
	bhs: "Testimoni",
};
export const LOCATIONS = {
	eng: "Location(s)",
	bhs: "Lokasi",
};
export const OPEN_IN_MAP = {
	eng: "Open in Map",
	bhs: "Lihat di Peta",
};
export const CAMPUS_NUM = {
	eng: "Campus {0}",
	bhs: "Kampus {0}",
};

// Major Details
export const MAJOR_NOT_FOUND = {
	eng: "Selected major not found!",
	bhs: "Tidak dapat menemukan jurusan terpilih",
};
export const FACULTY = {
	eng: "Faculty",
	bhs: "Fakultas",
};
export const MAJOR_DESCRIPTION = {
	eng: "Major Description",
	bhs: "Deskripsi Jurusan",
};
export const REGISTRATION_FEE = {
	eng: "Registration Fee",
	bhs: "Biaya Pendaftaran",
};
export const DEGREE_INFORMATION = {
	eng: "Degree Information",
	bhs: "Gelar",
};
export const STUDY_TIME = {
	eng: "Study Time (Years)",
	bhs: "Lama Studi (Tahun)",
};
export const SKS = {
	eng: "SKS",
	bhs: "SKS",
};
export const NUMBER_STUDENT = {
	eng: "Number of Student",
	bhs: "Jumlah Siswa",
};
export const NUMBER_LECTURER = {
	eng: "Number of Lecturer",
	bhs: "Jumlah Dosen",
};
export const MAJOR_WEBSITE = {
	eng: "Major Website",
	bhs: "Website Jurusan",
};
export const MAJOR_EMAIL = {
	eng: "Major Email",
	bhs: "Email Jurusan",
};
export const MAJOR_PHONE = {
	eng: "Major Phone",
	bhs: "Telepon Jurusan",
};
export const REGISTRATION_INFO = {
	eng: "Registration Info",
	bhs: "Info Registrasi",
};
export const STUDY_FEES = {
	eng: "Study Fees",
	bhs: "Biaya Kuliah",
};
export const CURRICULUM = {
	eng: "Curriculum",
	bhs: "Kurikulum",
};
export const ACHIEVEMENTS = {
	eng: "Achievements",
	bhs: "Prestasi",
};
export const CONCENTRATION = {
	eng: "Concentration",
	bhs: "Konsentrasi",
};
export const CARRER_PATH = {
	eng: "Career Path",
	bhs: "Karier Terkait",
};
export const CARRER_PATH_DESC = {
	eng: "If you study in this major, you can work as:",
	bhs: "Jika kamu kuliah di jurusan ini, maka kamu dapat bekerja sebagai:",
};

// Career Details
export const CAREER_NOT_FOUND = {
	eng: "Selected career not found!",
	bhs: "Tidak dapat menemukan karier terpilih",
};
export const START_FROM = {
	eng: "Starts from",
	bhs: "Dimulai dari",
};
export const SALARY = {
	eng: "Salary",
	bhs: "Gaji",
};
export const MIN_DEGREE = {
	eng: "Minimum Degree",
	bhs: "Minimal Pendidikan",
};
export const CERTIFICATION = {
	eng: "Certification",
	bhs: "Sertifikasi",
};
export const CAREER_DESCRIPTION = {
	eng: "Career Description",
	bhs: "Deskripsi Karier",
};
export const FACT_STATS = {
	eng: "Fact Stats",
	bhs: "Fakta dan Statistik",
};
export const ROLE_RESPONSIBILITIES = {
	eng: "Role and Responsibilities",
	bhs: "Peran dan Tanggung Jawab",
};
export const REQUIRED_SKILLS = {
	eng: "Knowledge and Skills Required",
	bhs: "Pengetahuan dan Keahlian",
};
export const CAREER_PATH = {
	eng: "Career Path",
	bhs: "Jenjang Karier",
};
export const RELATED_MAJOR = {
	eng: "Faculty/Major Related",
	bhs: "Fakultas/Jurusan Terkait",
};

// Scholarship Details
export const SCHOLARSHIP_NOT_FOUND = {
	eng: "Selected scholarship not found!",
	bhs: "Tidak dapat menemukan beasiswa terpilih",
};
export const REGISTRATION_PERIOD = {
	eng: "Registration Period",
	bhs: "Pendaftaran",
};
export const SCHOLARSHIP_DESCRIPTION = {
	eng: "Scholarship Description",
	bhs: "Deskripsi Beasiswa",
};
export const REGISTRATION_TIMELINE = {
	eng: "Registration Timeline",
	bhs: "Info Proses Pendaftaran",
};
export const IMPORTANT_INFO = {
	eng: "Important Info",
	bhs: "Info Penting",
};
export const DOCUMENTS_REQUIRED = {
	eng: "Documents Required",
	bhs: "Berkas yang Dibutuhkan",
};
export const SPECIAL_REQS = {
	eng: "Special Requirements",
	bhs: "Syarat yang Perlu Diperhatikan",
};
export const LEVEL_OF_COMPS = {
	eng: "Competitiveness",
	bhs: "Tingkat Persaingan untuk Beasiswa",
};
export const SELECTION_PERIOD = {
	eng: "Selection Period",
	bhs: "Periode Seleksi Beasiswa",
};
export const CHECKING_ANNOUNCEMENT = {
	eng: "Checking Announcement",
	bhs: "Bagaimana Cara Mengetahui Saya Diterima atau Tidak?",
};
export const OTHER_EXPLANATION = {
	eng: "Other Explanation",
	bhs: "Penjelasan Lain-lain",
};
export const WHAT_BENEFIT = {
	eng: "What Benefit You Will Get?",
	bhs: "Benefit Apa Saja yang Didapat?",
};

// Favorite page
export const HOME = {
	eng: "Home",
	bhs: "Home",
};
export const NO_FAVORITE_TITLE = {
	eng: "You haven't save any favorite {0}",
	bhs: "Anda belum menyimpan {0} favorit Anda",
};
export const NO_FAVORITE_DESC = {
	eng: "Go to the {0} page here and mark as favorite",
	bhs: "Lihat halaman {0} di sini dan tandai sebagai favorit",
};
export const GENERAL_PAGE = {
	eng: "{0} Page",
	bhs: "Halaman {0}",
};
export const FAILED_FETCH_FAVORITES = {
	eng: "Failed to fetch favorites",
	bhs: "Gagal mendapatkan data favorit",
};
export const SUCCESS_ADD_FAVORITES = {
	eng: "Successfully adding this {0} to the favorite",
	bhs: "Berhasil menambahkan {0} ini ke favorit",
};
export const SUCCESS_REMOVE_FAVORITES = {
	eng: "Successfully removing this {0} from the favorite",
	bhs: "Berhasil menghapus {0} ini dari favorit",
};
export const FAILED_ADD_FAVORITES = {
	eng: "Failed to add this {0} to the favorite",
	bhs: "Gagal menambahkan {0} ini ke favorit",
};
export const FAILED_REMOVE_FAVORITES = {
	eng: "Failed to remove this {0} from the favorite",
	bhs: "Gagal menghapus {0} ini dari favorit",
};
export const CANNOT_GET_DATA = {
	eng: "Cannot get the sufficient data to do this operation",
	bhs: "Tidak dapat mendapatkan data untuk melakukan operasi ini",
};
export const SCROLL_TO_TOP = {
	eng: "Scroll to Top",
	bhs: "Scroll ke atas",
};
